module.exports = __webpack_public_path__ + "img/no_gift_card_found.faf6520b.png";